// Module: SnackbarContext.js
// Purpose: Back-compat shim. The legacy `useSnackbar().showSnackbar(msg, severity)`
//   API is preserved, but it now emits a DS Toast (via useToast) instead of the
//   old MUI Snackbar — so every existing useSnackbar consumer gets the DS toast
//   with zero changes. Requires <ToastProvider> to be an ancestor (see App.js).

import React, { createContext, useContext, useCallback } from 'react';
import { useToast } from '../components/ds';

const SnackbarContext = createContext({ showSnackbar: () => {} });

export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
  const toast = useToast();

  //--> MUI severities ('info' | 'success' | 'error' | 'warning') map 1:1 onto the
  //    DS toast variants; unknown values fall back to info.
  const showSnackbar = useCallback(
    (msg, sev = 'info') => {
      (toast[sev] || toast.info)(msg);
    },
    [toast]
  );

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarContext;
